import useEvent from '@lyearn/core/hooks/useEvent';
import { useTranslation } from '@lyearn/i18n';
import { EntityMediaFragment } from '@/features/messages/graphql/fragments/generated/MediaType';
import useQuestionPlayerResponse from '@/modules/user-survey/hooks/useQuestionPlayerResponse';
import QuestionPlayerContainer from '@/modules/user-survey/questions/components/QuestionPlayerContainer';
import { QuestionPlayerProps } from '@/modules/user-survey/questions/types';
import { CreateMediaInput, QuestionTextlengthEnum, ResourceResponseTypeEnum } from '@/types/schema';

import UserSurveyRichTextInput from '../../components/UserSurveyRichTextInput';

const TextQuestionPlayer = (props: QuestionPlayerProps) => {
  const { t } = useTranslation();
  const {
    variant,
    question,
    userSurveyQuestionSettings,
    error,
    useRichTextForComment,
    response,
    onChange,
    commentTitle,
    disabled,
    requireComments,
  } = props;
  const actions = useQuestionPlayerResponse({ response, onChange });

  const onChangeText = useEvent((textResponse: string) => {
    if (disabled) {
      return;
    }

    actions.onQuestionResponseChange({
      responseType: ResourceResponseTypeEnum.Text,
      textResponse,
      attachments: response?.questionSurveyResponse?.attachments,
    });
  });

  const onChangeMedias = useEvent((attachments: CreateMediaInput[]) => {
    if (disabled) {
      return;
    }

    actions.onQuestionResponseChange({
      responseType: ResourceResponseTypeEnum.Text,
      textResponse: response?.questionSurveyResponse?.textResponse,
      attachments: attachments,
    });
  });

  return (
    <QuestionPlayerContainer
      commentTitle={commentTitle}
      disabled={disabled}
      error={error}
      post={response?.post}
      question={question}
      requireComments={requireComments}
      useRichTextForComment={useRichTextForComment}
      userSurveyQuestionSettings={userSurveyQuestionSettings}
      variant={variant}
      onPostChange={actions.onPostChange}>
      <UserSurveyRichTextInput
        allowAttachments={disabled ? false : userSurveyQuestionSettings?.allowAttachmentsInResponse}
        className={variant === 'form' ? 'mt-16' : 'mt-32'}
        disabled={disabled}
        error={Boolean(error)}
        medias={
          (response?.questionSurveyResponse?.attachments as EntityMediaFragment[]) ?? undefined
        }
        multiline={question.settings?.textLength === QuestionTextlengthEnum.Long}
        placeholder={t('UserSurvey:LearnerDetails.TextQuestionPlaceholder')}
        value={response?.questionSurveyResponse?.textResponse || ''}
        onChangeMedias={onChangeMedias}
        onChangeText={onChangeText}
      />
    </QuestionPlayerContainer>
  );
};

export default TextQuestionPlayer;
